import {
  alphabeticalOrderDropdownOptions,
  alphabeticalReverseDropdownOptions
} from '@/infrastructure/Utils'

export default {
  areFiltersSelected: (state) => {
    const filterSelectedAll = state.selectedTopic.key === 'allTopics' &&
      state.selectedArea.key === 'allAreas' &&
      state.selectedYear.key === 'allYears'
    return !filterSelectedAll
  },

  getSelectedFiltersNumber: (state, getters, { selectedArea, selectedTopic, selectedYear }) => {
    const isDefaultFilter = (current) => ['allTopics', 'allAreas', 'allYears'].includes(current.key)
    const selectedFilters = [{ ...selectedTopic }, { ...selectedArea }, { ...selectedYear }]
    return getters.areFiltersSelected
      ? selectedFilters.reduce((acc, current) => !isDefaultFilter(current) ? acc + 1 : acc, 0)
      : 0
  },

  getSelectedFilter: (state) => (type) => {
    return state[`selected${type}`]
  },

  getSelectedPageSize: (state) => {
    return state.pagination.limit
  },

  getTotalResults: (state) => {
    return state.pagination.total
  },

  getTopicDropdownOptions: ({ topicDropdownOptions }) => {
    return alphabeticalOrderDropdownOptions(topicDropdownOptions)
  },

  getAreaDropdownOptions: ({ areaDropdownOptions }) => {
    return alphabeticalOrderDropdownOptions(areaDropdownOptions)
  },

  getYearDropdownOptions: (state) => {
    return alphabeticalReverseDropdownOptions(state.yearDropdownOptions)
  },

  getSelectedTopic: (state) => {
    return state.selectedTopic
  },
  getQueryParamError: (state) => {
    return state.queryParamError
  }
}
